import React from 'react';

type SvgwishlistProps = React.SVGProps<SVGSVGElement>;

const Svgwishlist: React.FC<SvgwishlistProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3686 5.99599C10.4942 3.8116 7.36851 3.224 5.02003 5.22425C2.67154 7.2245 2.34091 10.5688 4.18519 12.9345C5.71858 14.9014 10.3592 19.0498 11.8801 20.3925C12.0503 20.5427 12.1353 20.6178 12.2346 20.6474C12.3212 20.6731 12.416 20.6731 12.5026 20.6474C12.6018 20.6178 12.6869 20.5427 12.8571 20.3925C14.378 19.0498 19.0186 14.9014 20.552 12.9345C22.3962 10.5688 22.106 7.20346 19.7171 5.22425C17.3283 3.24504 14.243 3.8116 12.3686 5.99599Z"
      fillRule="evenodd"
      stroke="#54606F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.1583"
    />
  </svg>
);

export default Svgwishlist;
